import { useEffect } from "react";
import { AlertDialog, AlertDialogContent, AlertDialogTitle, AlertDialogDescription, AlertDialogFooter, AlertDialogAction } from "@core/components/ui/AlertDialog";
import LoginLink from "@core/layouts/header/components/common/LoginLink";
import { useDialog } from "@core/components/dialog/hooks/useDialog";
import { cn } from "@core/utils";

export default function LayerLoginPlayncAccount() {
  const { isOpen, open, toggle } = useDialog({ type: "dialog", name: "loginPlayncAccount" });

  // 초기 마운트 발생 시에만 실행
  useEffect(() => {
    open();
  }, []);

  return (
    <AlertDialog open={isOpen} onOpenChange={toggle}>
      <AlertDialogContent>
        {/* AlertDialogTitle: 접근성 때문에 필요 */}
        <AlertDialogTitle className={cn("visible-hidden")}>Alert</AlertDialogTitle>
        <AlertDialogDescription>
          PLAYNC 계정으로 전환된 계정입니다.
          <br />
          PLAYNC 아이디로 로그인해주세요.
        </AlertDialogDescription>
        <AlertDialogFooter>
          <AlertDialogAction asChild={true}>
            <LoginLink variant="bgPoint600" size="large" />
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
